export default __webpack_public_path__ + "static/media/benefit-3@2x.a39311f6.png";